import towable from './towable.png'
import motorized from './motorized.png'
import marine from './marine.png'
import cargo from './cargo.png'

export const DIVISION_IMAGES = {
  towable,
  motorized,
  marine,
  cargo,
}
